/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Suspended_Cannot_RegisterInputs */



/**
* | output |
* | --- |
* | "Suspended" |
*
* @param {Error_Suspended_Cannot_RegisterInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const error_suspended_cannot_register = /** @type {((inputs?: Error_Suspended_Cannot_RegisterInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Suspended_Cannot_RegisterInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suspendu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suspendido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Suspenso")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sospeso")
	return /** @type {LocalizedString} */ ("Suspended")
});